import "./_split-editor-layout.scss";

/**
 * Shared "form + live preview" two-column shell. Extracted from Plan/Product
 * editors, which hand-rolled the identical split (byte-identical CSS in two
 * separate files) before this existed - a third hand-roll (Proposals) is
 * exactly the point at which it becomes a shared component.
 *
 * `left` scrolls independently; `preview` is a permanently pinned column
 * that never scrolls with it (not `position: sticky` on a shared scroll
 * region, which only stays pinned while its own row is in view - this
 * gives the preview its own non-scrolling column instead). That's a real,
 * visible behavior change on Plan/Product (previously scrolled away with
 * the page) - see the calling pages' own comments for the specific tradeoff.
 *
 * `leftScrollRef`: optional ref forwarded onto the `__left` column itself -
 * the actual `overflow-y: auto` element. Needed by a caller (Plans) whose
 * content includes an `AnchorTabs` scroll-spy nav, which needs a real DOM
 * ref to the scrolling ancestor to observe against (see AnchorTabs' own
 * `scrollContainerRef` prop). Omit it and nothing changes for callers that
 * don't need it (Products, Proposals).
 *
 * `preview` is nullable - omitting the `__preview` column entirely (not
 * just rendering it empty) is how a caller's own "Hide preview" toggle
 * (Proposals, per the Liquid Glass design) collapses the form back to full
 * width, since a lone flex child with no sibling naturally fills 100%.
 */
const SplitEditorLayout = ({ left, preview, leftScrollRef, className = "" }) => (
  <div className={`split-editor-layout ${className}`.trim()}>
    <div className="split-editor-layout__left" ref={leftScrollRef}>{left}</div>
    {preview != null && (
      <div className="split-editor-layout__preview">{preview}</div>
    )}
  </div>
);

export default SplitEditorLayout;
